var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Button, Icon } from "@uigovpe/components";
var MB = 1024 * 1024;
var EXTENSION_LABEL = {
    jpg: "JPG",
    jpeg: "JPG",
    png: "PNG",
    webp: "WEBP",
    gif: "GIF",
    pdf: "PDF",
    txt: "TXT",
    csv: "CSV",
    doc: "DOC",
    docx: "DOCX",
    xls: "XLS",
    xlsx: "XLSX",
    ppt: "PPT",
    pptx: "PPTX",
};
var ALLOWED_LABELS = Array.from(new Set(Object.values(EXTENSION_LABEL))).join(", ");
function getExtension(fileName) {
    var dotIndex = fileName.lastIndexOf(".");
    return dotIndex >= 0 ? fileName.slice(dotIndex + 1).toLowerCase() : "";
}
export var FileUpload = function (_a) {
    var value = _a.value, onChange = _a.onChange, onError = _a.onError, _b = _a.maxFiles, maxFiles = _b === void 0 ? 6 : _b, _c = _a.maxSizeMB, maxSizeMB = _c === void 0 ? 10 : _c;
    var inputRef = useRef(null);
    var maxSizeBytes = maxSizeMB * MB;
    var handleChange = function (e) {
        var _a;
        var selected = Array.from((_a = e.target.files) !== null && _a !== void 0 ? _a : []);
        var validFiles = selected.filter(function (f) {
            if (!(getExtension(f.name) in EXTENSION_LABEL)) {
                onError === null || onError === void 0 ? void 0 : onError("".concat(f.name, ": tipo de arquivo n\u00E3o suportado. Envie apenas: ").concat(ALLOWED_LABELS, "."));
                return false;
            }
            if (f.size > maxSizeBytes) {
                onError === null || onError === void 0 ? void 0 : onError("Cada arquivo deve ter no m\u00E1ximo ".concat(maxSizeMB, "MB."));
                return false;
            }
            return true;
        });
        var remaining = Math.max(0, maxFiles - value.length);
        var toAdd = validFiles.slice(0, remaining);
        if (validFiles.length > remaining) {
            onError === null || onError === void 0 ? void 0 : onError("Voc\u00EA pode anexar no m\u00E1ximo ".concat(maxFiles, " arquivos."));
        }
        if (toAdd.length > 0) {
            onChange(__spreadArray(__spreadArray([], value, true), toAdd, true));
        }
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };
    var handleRemove = function (index) {
        onChange(value.filter(function (_, i) { return i !== index; }));
    };
    var formatSize = function (bytes) {
        if (bytes < MB)
            return "".concat((bytes / 1024).toFixed(1), " KB");
        return "".concat((bytes / MB).toFixed(1), " MB");
    };
    return (_jsxs("div", __assign({ className: "space-y-2" }, { children: [_jsx(Button, { type: "button", label: "Selecionar documentos", icon: _jsx(Icon, { icon: "upload", className: "text-base" }), outlined: true, onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: value.length >= maxFiles, className: "w-full justify-start", pt: {
                    root: { className: "gap-2" },
                } }), _jsx("input", { ref: inputRef, id: "file-upload-input", type: "file", multiple: true, onChange: handleChange, style: { display: "none" }, "aria-label": "Selecionar documentos", "data-testid": "file-input" }), value.length > 0 && (_jsx("ul", __assign({ className: "mt-2 space-y-1 list-none p-0" }, { children: value.map(function (file, index) { return (_jsxs("li", __assign({ className: "flex items-center justify-between rounded border border-gray-200 bg-gray-50 px-3 py-2" }, { children: [_jsxs("span", __assign({ className: "text-sm text-gray-800 truncate" }, { children: [file.name, _jsxs("span", __assign({ className: "ml-2 text-xs text-gray-500" }, { children: ["(", formatSize(file.size), ")"] }))] })), _jsx("button", __assign({ type: "button", "aria-label": "remover ".concat(file.name), onClick: function () { return handleRemove(index); }, className: "ml-3 flex shrink-0 items-center justify-center rounded-full w-6 h-6 bg-white border border-red-200 hover:bg-red-50 transition-colors" }, { children: _jsx(Icon, { icon: "close", className: "text-red-500", style: { fontSize: "14px" } }) }))] }), "".concat(file.name, "-").concat(file.size, "-").concat(file.lastModified))); }) })))] })));
};
